import React, { useState } from "react";
import { RefreshCw } from "lucide-react";

const STATUS = {
  enviado: { label: "Enviado", bg: "#e3ecd2", fg: "#3f5a1f" },
  pendiente: { label: "Pendiente", bg: "#f6ecd2", fg: "#8a6a1c" },
  enviando: { label: "Enviando…", bg: "#f6ecd2", fg: "#8a6a1c" },
  error: { label: "Reintentando", bg: "#f6dccf", fg: "#9a4524" },
  omitido: { label: "No enviado", bg: "#ece9e1", fg: "#6b6658" },
};

export const GestionStatus = ({ sub, onResend }) => {
  const [busy, setBusy] = useState(false);
  const st = STATUS[sub.gestion_status] || STATUS.pendiente;
  const tip = sub.gestion_status === "enviado"
    ? `Enviado ${sub.gestion_sent_at ? new Date(sub.gestion_sent_at).toLocaleString("es-ES") : ""}`
    : `${sub.gestion_attempts || 0} intentos${sub.gestion_last_error ? ` · ${sub.gestion_last_error}` : ""}`;

  const resend = async () => {
    if (sub.gestion_status === "omitido" && !window.confirm("Este registro estaba marcado como «No enviado». ¿Seguro que quieres enviarlo a la app de gestión?")) return;
    setBusy(true);
    await onResend(sub);
    setBusy(false);
  };

  return (
    <div className="flex items-center gap-2 whitespace-nowrap">
      <span
        title={tip}
        className="px-2.5 py-1 rounded-full text-xs font-medium"
        style={{ background: st.bg, color: st.fg }}
        data-testid={`gestion-status-${sub.id}`}
      >
        {st.label}
      </span>
      <button
        onClick={resend}
        disabled={busy || sub.gestion_status === "enviando"}
        title="Reenviar a la app de gestión"
        className="transition-transform hover:rotate-90 disabled:opacity-40"
        data-testid={`gestion-resend-${sub.id}`}
      >
        <RefreshCw size={15} className={busy ? "animate-spin" : ""} style={{ color: "var(--sage-600)" }} />
      </button>
    </div>
  );
};
